/** Параметр адреси списку, що відкриває чернетку нового запису в правій панелі розділеного вигляду (`?new=1`). */
export const SPLIT_DRAFT_PARAM = 'new';

/** Типи записів, чий розділений вигляд зараз відкрито (лічильник монтувань). */
const hosts = new Map<string, number>();

/**
 * Зареєструвати розділений вигляд типу як місце для чернетки нового запису (прототип v4: «+ Створити» в розділеному вигляді відкриває
 * новий запис у правій панелі, а не на окремій сторінці); повертає скасування реєстрації.
 */
export function holdSplitHost(rtKey: string): () => void {
  hosts.set(rtKey, (hosts.get(rtKey) ?? 0) + 1);
  return () => {
    const left = (hosts.get(rtKey) ?? 1) - 1;
    if (left > 0) hosts.set(rtKey, left);
    else hosts.delete(rtKey);
  };
}

/** Чи відкрито зараз розділений вигляд типу (тоді чернетка нового запису відкривається в його панелі). */
export function isSplitHost(rtKey: string): boolean {
  return (hosts.get(rtKey) ?? 0) > 0;
}
